/* APEXX · Buy Box — assets/apexx-buy-box.js
   Variant swatch selection → updates hidden id, price, button label, and the
   "Colour: X" caption. Works per-section instance and re-binds in the editor. */
(function () {
  function money(cents, fmt) {
    // fmt like "€{{amount}}" or with comma decimals; fall back to simple EUR.
    var v = (cents / 100);
    var s = v.toFixed(2);
    if (fmt && fmt.indexOf(',') > -1) s = s.replace('.', ',');
    return (fmt && fmt.replace(/\{\{\s*amount\s*\}\}/, s)) || ('€' + s);
  }

  function bind(root) {
    (root || document).querySelectorAll('.apexx-bb').forEach(function (bb) {
      if (bb.dataset.bbBound) return;
      bb.dataset.bbBound = '1';

      var form = bb.querySelector('[data-bb-form]');
      var idInput = bb.querySelector('[data-bb-id]');
      var priceEls = bb.querySelectorAll('[data-bb-price]');
      var caption = bb.querySelector('[data-bb-chosen]');
      var btn = bb.querySelector('[data-bb-btn]');
      var fmt = bb.getAttribute('data-money') || '';
      var swatches = bb.querySelectorAll('.apexx-bb__swatch');

      function select(sw) {
        if (!sw || sw.disabled) return;
        swatches.forEach(function (s) { s.setAttribute('aria-pressed', s === sw ? 'true' : 'false'); });
        if (idInput) idInput.value = sw.dataset.variantId || idInput.value;
        if (caption) caption.textContent = sw.dataset.name || '';
        var p = sw.dataset.price;
        if (p) priceEls.forEach(function (el) { el.textContent = p; });
      }

      swatches.forEach(function (sw) {
        sw.addEventListener('click', function () { select(sw); });
      });

      // submit feedback (don't block real /cart/add navigation in theme;
      // in preview there is no action so we show a toast state)
      if (form && btn) {
        form.addEventListener('submit', function (e) {
          if (!form.getAttribute('action')) {
            e.preventDefault();
            var html = btn.innerHTML;
            btn.innerHTML = 'Added \u2713';
            btn.style.background = '#1f8a5b';
            setTimeout(function () { btn.innerHTML = html; btn.style.background = ''; }, 1300);
          }
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () { bind(document); });
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
